var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobspaceIconSqHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 440,
    viewBox: "0 0 441 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233 233L414 413",
    stroke: "#1AAA55",
    strokeWidth: 50
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280 280L414 413",
    stroke: "#1AAA55",
    strokeWidth: 75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.764 268.527C214.012 268.527 268.527 214.012 268.527 146.764C268.527 79.5154 214.012 25 146.764 25C79.5154 25 25 79.5154 25 146.764C25 214.012 79.5154 268.527 146.764 268.527Z",
    stroke: "#1AAA55",
    strokeWidth: 50
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.748 146.763C162.271 146.763 174.855 134.179 174.855 118.656C174.855 103.133 162.271 90.5488 146.748 90.5488C131.225 90.5488 118.641 103.133 118.641 118.656C118.641 134.179 131.225 146.763 146.748 146.763Z",
    fill: "#1AAA55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.93 207.643C106.93 151.429 186.583 151.429 186.583 207.643H106.93Z",
    fill: "#1AAA55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobspaceIconSqHandle);
export default __webpack_public_path__ + "static/media/jobspace-icon-sq_handle.cf01239524366fc33f6d59e5fb07533a.svg";
export { ForwardRef as ReactComponent };